module.exports = __WEBPACK_EXTERNAL_MODULE_100__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = 100
// module chunks = 0